.link {
  &:not(:disabled):hover {
    text-decoration: none;
  }
}
